import React from 'react';
import { useDispatch } from 'react-redux';
import { updateConfigConditions, changeConfigContainerVisibility } from '@store/errorLogicConfig/configContainer/actions';
import { setWarningContainerVisibility } from '@store/errorLogicConfig/base/actions';
import { getItems } from './utils';
import { Dropdown, Space } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const configStateCode = {
  enable: 2,
  disable: 1,
  delete: 0,
};

function KebabColumn({ rowData }) {
  const dispatch = useDispatch();

  const { parentId = null } = rowData;
  if (parentId !== null) { return null; }
  const onApply = ({ key: selectedMenuItem }:any) => {
    const state = selectedMenuItem in configStateCode ? configStateCode[selectedMenuItem] : rowData.state;
    dispatch(updateConfigConditions(
      {
        id: rowData.id,
        name: rowData.name,
        rules: rowData.rawRules,
        state,
      },
    ));
    if (selectedMenuItem === 'edit') {
      dispatch(changeConfigContainerVisibility(true));
    } else {
      dispatch(setWarningContainerVisibility(true));
    }
  };
  const itemList = getItems(rowData.state);

  return (
    <Dropdown
      menu={{ items: itemList, onClick: onApply }}
      trigger={['click']}
    >
      <Space>
        <MoreOutlined />
      </Space>
    </Dropdown>
  );
}

export default KebabColumn;
